import profileicon from '../assets/images/header-menus/profile-icon.svg'
import { Suspense, lazy, useEffect } from 'react';
import kycicon from '../assets/images/header-menus/kyc-icon.svg'
import helpicon from '../assets/images/header-menus/help-icon.svg'
import settingsicon from '../assets/images/header-menus/settings-icon.svg'
import termsicon from '../assets/images/header-menus/terms-icon.svg'
import logouticon from '../assets/images/header-menus/logout-icon.svg'
import cardicon from '../assets/images/header-menus/card-pos.svg'
import MyCredits from '../components/User/MyCredits'
const Profile = lazy(()=> import('../components/User/Profile'))
const KYC = lazy(()=> import('../components/User/KYC'))
const HelpAndSupport = lazy(()=> import('../components/User/HelpAndSupport'))
const Settings = lazy(()=> import('../components/User/Settings'))
const TermsAndConditions = lazy(()=> import('../components/User/TermsAndConditions'))

const headermenus = [
    {
        path: 'user/profile',
        slug:'profile',
        name: 'Profile',
        menuicon: profileicon,
        role: ['customer'],
        pagetitle : 'Personal Details',
        component : Profile
    },
    {
        path: 'user/kyc',
        slug:'kyc',
        name: 'KYC',
        menuicon: kycicon,
        role: ['customer'],
        pagetitle : 'Organization Details',
        component : KYC,
        // Menu clicks (user sidebar, header dropdown, /home account menu) open
        // the new KYB flow inside the user layout instead; /user/kyc itself
        // stays routed and is still reachable by direct URL.
        navTo : '/user/business-verification',
    },
    {
        path: 'user/help-and-support',
        slug:'help-and-support',
        name: 'Help and Support',
        menuicon: helpicon,
        role: ['customer'],
        pagetitle : 'Send Request Message',
        component : HelpAndSupport
    },
    {
        path: 'user/settings',
        slug:'settings',
        name: 'Settings',
        menuicon: settingsicon,
        role: ['customer'],
        pagetitle : 'Theme',
        component : Settings
    },
    {
        path: 'user/terms-and-conditions',
        slug:'terms-and-conditions',
        name: 'Terms and conditions',
        menuicon: termsicon,
        role: ['customer'],
        pagetitle : 'Terms and conditions',
        component : TermsAndConditions
    },
    {
        path: 'user/my-credits',
        slug:'my-credits',
        name: 'My Credits',
        menuicon: cardicon,
        role: ['customer'],
        pagetitle : 'My Credits',
        component : MyCredits
    },
    {
        path: 'logout',
        slug:'logout',
        name: 'Logout',
        menuicon: logouticon,
        role: ['customer'],
        pagetitle : 'Logout'
    }
    
]

export default headermenus
// import dashboardicon from '../assets/images/menu-icons/dashboard.svg'
// import activedashboardicon from '../assets/images/menu-icons/active-dashboard.svg'
// import searchrates from '../assets/images/menu-icons/searchrates.svg'
// import activesearchrates from '../assets/images/menu-icons/active-searchrates.svg'
// import bookinghistory from '../assets/images/menu-icons/booking-history.svg'
// import activebookinghistory from '../assets/images/menu-icons/active-booking-history.svg'
// import queries from '../assets/images/menu-icons/queries.svg'
// import activequeries from '../assets/images/menu-icons/active-queries.svg'
// import Dashboard from '../pages/Dashboard'
// import SearchRates from '../pages/SearchRates'
// import BookingHistory from '../pages/BookingHistory'
// import Queries from '../pages/Queries'


// // below this are admin routes
// import AcceptedQuoteManagement from "../pages/Admin/AcceptedQuoteManagement"
// import Archives from "../pages/Admin/Archives"
// import CreateKeyAccountManager from "../pages/Admin/CreateKeyAccountManager"
// import DashboardPage from "../pages/Admin/DashboardPage"
// import ExchangeRate from "../pages/Admin/ExchangeRate"
// import KYCVerifications from "../pages/Admin/KYCVerifications"
// import Queriesadmin from "../pages/Admin/Queries"
// import RateManagement from "../pages/Admin/RateManagement"
// import RejectedQuoteManagement from "../pages/Admin/RejectedQuoteManagement"
// // import Report from "../../pages/Admin/Report"
// import TransportationRateManagement from "../pages/Admin/TransportationRateManagement"
// import UserManagement from "../pages/Admin/UserManagement"
// import UserManagementAdmin from "../pages/Admin/UserManagementAdmin"

// export const routs = [
//     // {
//     //     path: '',
//     //     name: 'Dashboard',
//     //     menuicon: dashboardicon,
//     //     menuiconActive: activedashboardicon,
//     //     role: ['customer'],
//     //     component : Dashboard
//     // },
//     {
//         path: '/search-rates',
//         name: 'Search Rates',
//         menuicon: searchrates,
//         menuiconActive: activesearchrates,
//         role: ['customer'],
//         component : SearchRates
//     },
//     {
//         path: '/queries',
//         name: 'Queries',
//         menuicon: queries,
//         menuiconActive: activequeries,
//         role: ['customer'],
//         component : Queries
//     },
//     {
//         path: '/booking-history',
//         name: 'Booking History',
//         menuicon: bookinghistory,
//         menuiconActive: activebookinghistory,
//         role: ['customer'],
//         component : BookingHistory
//         //below this are admin routes
//     },
//     {
//         menuicon: require("../assets/admin/images/SideBarIcons/dashboard.png"),
//         menuiconActive: require("../assets/admin/images/SideBarIcons/dashboard_active.png"),
//         name: "Dashboard",
//         path: "/dashboard",
//         role: ['air_admin'],
//         component: DashboardPage
//     },
//     {
//         menuicon : require("../assets/admin/images/SideBarIcons/user_management.png"), 
//         menuiconActive: require("../assets/admin/images/SideBarIcons/user_management_active.png"),
//         name: "User Management",
//         path: "/user-management-admin",
//         role: ['air_admin'],
//         component: UserManagementAdmin
//     },
//     {
//         menuicon: require("../assets/admin/images/SideBarIcons/user_management.png"),
//         menuiconActive: require("../assets/admin/images/SideBarIcons/user_management_active.png"),
//         name: "User Management",
//         path: "/user-management",
//         role: ['kam'],
//         component: UserManagement
//     },
//     {
//         menuicon: require("../assets/admin/images/SideBarIcons/Vectorkyc.png"),
//         menuiconActive: require("../assets/admin/images/SideBarIcons/Vectorkyc_active.png"),
//         name: "KYC Verification",
//         path: "/kyc-verification",
//         role: ['air_admin'],
//         component: KYCVerifications
//     },
//     {
//         menuicon: require("../assets/admin/images/SideBarIcons/accepted_quotation.png"),
//         menuiconActive: require("../assets/admin/images/SideBarIcons/accepted_quotation_active.png"),
//         name: "Accepted Quotation Management",
//         path: "/accepted-quotation-management",
//         role: ['air_admin'],
//         component: AcceptedQuoteManagement
//     },
//     {
//         menuicon: require("../assets/admin/images/SideBarIcons/rejectedicon.png"),
//         menuiconActive: require("../assets/admin/images/SideBarIcons/rejectedactive.png"),
//         name: "Rejected Quotation Management",
//         path: "/rejected-quotation-management",
//         role: ['air_admin'],
//         component: RejectedQuoteManagement
//     },
//     {
//         menuicon: require("../assets/admin/images/SideBarIcons/rate_management.png"),
//         menuiconActive: require("../assets/admin/images/SideBarIcons/rate_management_active.png"),
//         name: "Rate Management",
//         path: "/rate-management",
//         role: ['air_admin'],
//         component: RateManagement
//     },
//     {
//         menuicon: require("../assets/admin/images/SideBarIcons/transportation.png"),
//         menuiconActive: require("../assets/admin/images/SideBarIcons/transportationActive.png"),
//         name: "Transportation Rate Management",
//         path: "/transportation-rate-management",
//         role: ['air_admin'],
//         component: TransportationRateManagement
//     },
//     {
//         menuicon: require("../assets/admin/images/SideBarIcons/create_key_account.png"),
//         menuiconActive: require("../assets/admin/images/SideBarIcons/create_key_account_active.png"),
//         name: "KAM Management",
//         path: "/create-key-account-manager",
//         role: ['air_admin'],
//         component: CreateKeyAccountManager
//     },
//     {
//         menuicon: require("../assets/admin/images/SideBarIcons/archives.png"),
//         menuiconActive: require("../assets/admin/images/SideBarIcons/archives_active.png"),
//         name: "Archives",
//         path: "/archives",
//         role: ['air_admin'],
//         component: Archives
//     },
//     {
//         menuicon: require("../assets/admin/images/SideBarIcons/queries_icon.png"),
//         menuiconActive: require("../assets/admin/images/SideBarIcons/queries_active.png"),
//         name: "Queries",
//         path: "/QueriesKAM",
//         role: ['kam'],
//         component: Queriesadmin
//     },
//     {
//         menuicon: require("../assets/admin/images/SideBarIcons/exchange_rate.png"),
//         menuiconActive: require("../assets/admin/images/SideBarIcons/exchange_rate.png"),
//         name: "Exchange Rate",
//         path: "/exchange-rate",
//         role: ['air_admin'],
//         component: ExchangeRate
//     },
//     {
//         menuicon: require("../assets/admin/images/SideBarIcons/payment_request.png"),
//         menuiconActive: require("../assets/admin/images/SideBarIcons/payment_req_active.png"),
//         name: "Payment Requests",
//         path: "/payment-request",
//         role: ['air_admin'],
//         component: PaymentRequest
//     }
//     // ,
//     // {
//     //     icon: require("../assets/images/SideBarIcons/reports.png"),
//     //     active_icon: require("../assets/images/SideBarIcons/report_active.png"),
//     //     label: "Reports",
//     //     path: "/reports",
//     //     role: ['admin','air_admin','ocean_admin'],
//     //     component: Report
//     // }
    

    
    
// ]

// export default routs